import { render } from "./CBoxEventos.vue?vue&type=template&id=2e395415&scoped=true"
import script from "./CBoxEventos.vue?vue&type=script&lang=js"
export * from "./CBoxEventos.vue?vue&type=script&lang=js"

import "./CBoxEventos.vue?vue&type=style&index=0&id=2e395415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e395415"]])

export default __exports__